<template>
  <div class="q-pa-md q-gutter-md">
    <q-btn color="primary" no-caps label="Copy link to this page" @click="clip_board_order_link"></q-btn>
    <q-btn v-if="isAuthenticated" color="secondary" no-caps label="Generate Short Url" @click="process_link"></q-btn>
  </div>
</template>

<script>
import { ref } from "vue";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-vue";
import OrderLinks from "src/composables/OrderLinks";
import { contact_center_api, orders_api } from "boot/axios";
import { Notify, copyToClipboard } from "quasar";
import Analytics from "src/composables/Analytics";


export default {
  name: "GetOrderLinkModal",
  setup() {
    const { order_query_string, order_link } = OrderLinks()
    const { isAuthenticated, getAccessTokenSilently } = useAuth0();
    const { log_event } = Analytics();
    const open = ref(false);
    const loading = ref(false);
    const user_token = ref(null);
    const order_short_link = ref(null);

    const clip_board_order_link = function () {
      log_event({
        name: 'get_order_link_full_clicked',
        link_short: order_short_link.value,
        link_full: order_link.value
      })
      copyToClipboard(order_link.value).then(() => {
        log_event({
          name: 'get_order_link_full_copied',
          link_short: order_short_link.value,
          link_full: order_link.value
        })
        Notify.create({
          message: 'Your link is copied to the clipboard',
          color: 'positive',
          actions: [
            { label: 'Dismiss', color: 'white' }
          ]
        })
      })
    }

    const process_link = async () => {
      try {
        log_event({
          name: 'get_order_link_short_clicked',
          link_short: order_short_link.value,
          link_full: order_link.value
        })
        loading.value = true;
        const token = await getAccessTokenSilently();
        user_token.value = token;
        let url = `${ process.env.VUE_APP_CONTACT_CENTER_URL }/api/calls/order_links`;
        let { data } = await axios.post(url,
            {
              order_url: order_link.value
            },
            {
              headers: {
                Authorization: `Bearer ${ token }`
              }
            });
        order_short_link.value = data?.short_url;
        log_event({
          name: 'get_order_link_short_generated',
          link_short: order_short_link.value,
          link_full: order_link.value
        })
        copyToClipboard(order_short_link.value).then(() => {
          log_event({
            name: 'get_order_link_short_copied',
            link_short: order_short_link.value,
            link_full: order_link.value
          })
          Notify.create({
            message: 'Short Url Copied to clipboard.',
            color: 'positive',
            actions: [
              { label: 'Dismiss', color: 'white' }
            ]
          })
        })
      }
      catch (err) {
        Notify.create({
          message: err?.response?.data?.message || 'Unable to create short url.',
          color: 'negative',
          actions: [
            { label: 'Dismiss', color: 'white' }
          ]
        })
        return null;
      }
      finally {
        loading.value = false;
      }
    }

    return {
      order_link,
      order_short_link,
      user_token,
      clip_board_order_link,
      process_link,
      isAuthenticated,
      open
    }
  }
}
</script>

<style scoped>

</style>
